var items = {
  "block.minecraft.air": "oras",
  "block.minecraft.stone": "akmuo",
  "block.minecraft.granite": "granitas",
  "block.minecraft.polished_granite": "šlifuotas granitas",
  "block.minecraft.diorite": "dioritas",
  "block.minecraft.polished_diorite": "šlifuotas dioritas",
  "block.minecraft.andesite": "andezitas",
  "block.minecraft.polished_andesite": "šlifuotas andezitas",
  "block.minecraft.grass_block": "žolės blokas",
  "block.minecraft.dirt": "žemė",
  "block.minecraft.coarse_dirt": "šiurkšti žemė",
  "block.minecraft.podzol": "jaura",
  "block.minecraft.crimson_nylium": "raudonio grybiena",
  "block.minecraft.warped_nylium": "klaikioji grybiena",
  "block.minecraft.cobblestone": "akmens skalda",
  "block.minecraft.oak_planks": "ąžuolo lentos",
  "block.minecraft.spruce_planks": "eglės lentos",
  "block.minecraft.birch_planks": "beržo lentos",
  "block.minecraft.jungle_planks": "džiunglių medžio lentos",
  "block.minecraft.acacia_planks": "akacijos lentos",
  "block.minecraft.dark_oak_planks": "tamsiojo ąžuolo lentos",
  "block.minecraft.crimson_planks": "raudonio lentos",
  "block.minecraft.warped_planks": "klaikiosios lentos",
  "block.minecraft.oak_sapling": "ąžuolo sodinukas",
  "block.minecraft.spruce_sapling": "eglės sodinukas",
  "block.minecraft.birch_sapling": "beržo sodinukas",
  "block.minecraft.jungle_sapling": "džiunglių medžio sodinukas",
  "block.minecraft.acacia_sapling": "akacijos sodinukas",
  "block.minecraft.dark_oak_sapling": "tamsiojo ąžuolo sodinukas",
  "block.minecraft.bedrock": "pamatakmenis",
  "block.minecraft.sand": "smėlis",
  "block.minecraft.red_sand": "raudonasis smėlis",
  "block.minecraft.gravel": "žvyras",
  "block.minecraft.gold_ore": "aukso rūda",
  "block.minecraft.iron_ore": "geležies rūda",
  "block.minecraft.coal_ore": "anglies rūda",
  "block.minecraft.nether_gold_ore": "neterio aukso rūda",
  "block.minecraft.oak_log": "ąžuolo rąstas",
  "block.minecraft.spruce_log": "eglės rąstas",
  "block.minecraft.birch_log": "beržo rąstas",
  "block.minecraft.jungle_log": "džiunglių medžio rąstas",
  "block.minecraft.acacia_log": "akacijos rąstas",
  "block.minecraft.dark_oak_log": "tamsiojo ąžuolo rąstas",
  "block.minecraft.crimson_stem": "raudonio stiebas",
  "block.minecraft.warped_stem": "klaikusis stiebas",
  "block.minecraft.stripped_oak_log": "obliuotas ąžuolo rąstas",
  "block.minecraft.stripped_spruce_log": "obliuotas eglės rąstas",
  "block.minecraft.stripped_birch_log": "obliuotas beržo rąstas",
  "block.minecraft.stripped_jungle_log": "obliuotas džiunglių medžio rąstas",
  "block.minecraft.stripped_acacia_log": "obliuotas akacijos rąstas",
  "block.minecraft.stripped_dark_oak_log": "obliuotas tamsiojo ąžuolo rąstas",
  "block.minecraft.stripped_crimson_stem": "obliuotas raudonio stiebas",
  "block.minecraft.stripped_warped_stem": "obliuotas klaikusis stiebas",
  "block.minecraft.stripped_oak_wood": "obliuotas ąžuolo medis",
  "block.minecraft.stripped_spruce_wood": "obliuotas eglės medis",
  "block.minecraft.stripped_birch_wood": "obliuotas beržo medis",
  "block.minecraft.stripped_jungle_wood": "obliuotas džiunglių medis",
  "block.minecraft.stripped_acacia_wood": "obliuotas akacijos medis",
  "block.minecraft.stripped_dark_oak_wood": "obliuotas tamsiojo ąžuolo medis",
  "block.minecraft.stripped_crimson_hyphae": "obliuoti raudonio hifai",
  "block.minecraft.stripped_warped_hyphae": "obliuoti klaikieji hifai",
  "block.minecraft.oak_wood": "ąžuolo medis",
  "block.minecraft.spruce_wood": "eglės medis",
  "block.minecraft.birch_wood": "beržo medis",
  "block.minecraft.jungle_wood": "džiunglių medžio medis",
  "block.minecraft.acacia_wood": "akacijos medis",
  "block.minecraft.dark_oak_wood": "tamsiojo ąžuolo medis",
  "block.minecraft.crimson_hyphae": "raudonio hifai",
  "block.minecraft.warped_hyphae": "klaikieji hifai",
  "block.minecraft.oak_leaves": "ąžuolo lapai",
  "block.minecraft.spruce_leaves": "eglės spygliai",
  "block.minecraft.birch_leaves": "beržo lapai",
  "block.minecraft.jungle_leaves": "džiunglių medžio lapai",
  "block.minecraft.acacia_leaves": "akacijos lapai",
  "block.minecraft.dark_oak_leaves": "tamsiojo ąžuolo lapai",
  "block.minecraft.sponge": "kempinė",
  "block.minecraft.wet_sponge": "šlapia kempinė",
  "block.minecraft.glass": "stiklas",
  "block.minecraft.lapis_ore": "lazurito rūda",
  "block.minecraft.lapis_block": "lazurito blokas",
  "block.minecraft.dispenser": "dalytuvas",
  "block.minecraft.sandstone": "smiltainis",
  "block.minecraft.chiseled_sandstone": "raižytas smiltainis",
  "block.minecraft.cut_sandstone": "šlifuotas smiltainis",
  "block.minecraft.note_block": "natų blokas",
  "block.minecraft.powered_rail": "greitintuvas",
  "block.minecraft.detector_rail": "detektoriniai bėgiai",
  "block.minecraft.sticky_piston": "lipnus stūmoklis",
  "block.minecraft.cobweb": "voratinklis",
  "block.minecraft.grass": "žolė",
  "block.minecraft.fern": "papartis",
  "block.minecraft.dead_bush": "negyvas krūmas",
  "block.minecraft.seagrass": "jūržolė",
  "block.minecraft.sea_pickle": "jūros agurkas",
  "block.minecraft.piston": "stūmoklis",
  "block.minecraft.white_wool": "balta vilna",
  "block.minecraft.orange_wool": "oranžinė vilna",
  "block.minecraft.magenta_wool": "šviesiai purpurinė vilna",
  "block.minecraft.light_blue_wool": "žydra vilna",
  "block.minecraft.yellow_wool": "geltona vilna",
  "block.minecraft.lime_wool": "šviesiai žalia vilna",
  "block.minecraft.pink_wool": "rausva vilna",
  "block.minecraft.gray_wool": "pilka vilna",
  "block.minecraft.light_gray_wool": "šviesiai pilka vilna",
  "block.minecraft.cyan_wool": "tamsiai žydra vilna",
  "block.minecraft.purple_wool": "purpurinė vilna",
  "block.minecraft.blue_wool": "mėlyna vilna",
  "block.minecraft.brown_wool": "ruda vilna",
  "block.minecraft.green_wool": "žalia vilna",
  "block.minecraft.red_wool": "raudona vilna",
  "block.minecraft.black_wool": "juoda vilna",
  "block.minecraft.dandelion": "pienė",
  "block.minecraft.poppy": "aguona",
  "block.minecraft.blue_orchid": "mėlynoji orchidėja",
  "block.minecraft.allium": "česnakas",
  "block.minecraft.azure_bluet": "žydroji bajorė",
  "block.minecraft.red_tulip": "raudona tulpė",
  "block.minecraft.orange_tulip": "oranžinė tulpė",
  "block.minecraft.white_tulip": "balta tulpė",
  "block.minecraft.pink_tulip": "rausva tulpė",
  "block.minecraft.oxeye_daisy": "paprastoji baltagalvė",
  "block.minecraft.cornflower": "rugiagėlė",
  "block.minecraft.lily_of_the_valley": "pakalnutė",
  "block.minecraft.wither_rose": "viterio rožė",
  "block.minecraft.brown_mushroom": "rudas grybas",
  "block.minecraft.red_mushroom": "raudonas grybas",
  "block.minecraft.crimson_fungus": "raudonio grybas",
  "block.minecraft.warped_fungus": "klaikusis grybas",
  "block.minecraft.crimson_roots": "raudonio šaknys",
  "block.minecraft.warped_roots": "klaikiosios šaknys",
  "block.minecraft.nether_sprouts": "neterio daigai",
  "block.minecraft.weeping_vines": "raudonio vijokliai",
  "block.minecraft.twisting_vines": "klaikieji vijokliai",
  "block.minecraft.sugar_cane": "cukranendrė",
  "block.minecraft.kelp": "rudadumbliai",
  "block.minecraft.bamboo": "bambukas",
  "block.minecraft.gold_block": "aukso blokas",
  "block.minecraft.iron_block": "geležies blokas",
  "block.minecraft.oak_slab": "ąžuolo pusblokis",
  "block.minecraft.spruce_slab": "eglės pusblokis",
  "block.minecraft.birch_slab": "beržo pusblokis",
  "block.minecraft.jungle_slab": "džiunglių medžio pusblokis",
  "block.minecraft.acacia_slab": "akacijos pusblokis",
  "block.minecraft.dark_oak_slab": "tamsiojo ąžuolo pusblokis",
  "block.minecraft.crimson_slab": "raudonio pusblokis",
  "block.minecraft.warped_slab": "klaikusis pusblokis",
  "block.minecraft.stone_slab": "akmens pusblokis",
  "block.minecraft.smooth_stone_slab": "lygaus akmens pusblokis",
  "block.minecraft.sandstone_slab": "smiltainio pusblokis",
  "block.minecraft.cut_sandstone_slab": "šlifuoto smiltainio pusblokis",
  "block.minecraft.petrified_oak_slab": "suakmenėjęs ąžuolo pusblokis",
  "block.minecraft.cobblestone_slab": "akmens skaldos pusblokis",
  "block.minecraft.brick_slab": "plytų pusblokis",
  "block.minecraft.stone_brick_slab": "akmens plytų pusblokis",
  "block.minecraft.nether_brick_slab": "neterio plytų pusblokis",
  "block.minecraft.quartz_slab": "kvarco pusblokis",
  "block.minecraft.red_sandstone_slab": "raudonojo smiltainio pusblokis",
  "block.minecraft.cut_red_sandstone_slab": "šlifuoto raudonojo smiltainio pusblokis",
  "block.minecraft.purpur_slab": "purpuro pusblokis",
  "block.minecraft.prismarine_slab": "prizmarino pusblokis",
  "block.minecraft.prismarine_brick_slab": "prismarino plytų pusblokis",
  "block.minecraft.dark_prismarine_slab": "tamsiojo prizmarino pusblokis",
  "block.minecraft.smooth_quartz": "lygus kvarco blokas",
  "block.minecraft.smooth_red_sandstone": "lygus raudonasis smiltainis",
  "block.minecraft.smooth_sandstone": "lygus smiltainis",
  "block.minecraft.smooth_stone": "lygus akmuo",
  "block.minecraft.bricks": "plytos",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "knygų lentyna",
  "block.minecraft.mossy_cobblestone": "samanota akmens skalda",
  "block.minecraft.obsidian": "obsidianas",
  "block.minecraft.torch": "deglas",
  "block.minecraft.end_rod": "endo strypas",
  "block.minecraft.chorus_plant": "koruso augalas",
  "block.minecraft.chorus_flower": "koruso gėlė",
  "block.minecraft.purpur_block": "purpuro blokas",
  "block.minecraft.purpur_pillar": "purpuro kolonos blokas",
  "block.minecraft.purpur_stairs": "purpuro laiptai",
  "block.minecraft.spawner": "atsiradimo narvas",
  "block.minecraft.oak_stairs": "ąžuolo laiptai",
  "block.minecraft.chest": "skrynia",
  "block.minecraft.diamond_ore": "deimanto rūda",
  "block.minecraft.diamond_block": "deimanto blokas",
  "block.minecraft.crafting_table": "darbastalis",
  "block.minecraft.farmland": "išarta žemė",
  "block.minecraft.furnace": "krosnis",
  "block.minecraft.ladder": "kopėčios",
  "block.minecraft.rail": "bėgiai",
  "block.minecraft.cobblestone_stairs": "akmens skaldos laiptai",
  "block.minecraft.lever": "svirtis",
  "block.minecraft.stone_pressure_plate": "akmeninė slėgio plokštė",
  "block.minecraft.oak_pressure_plate": "ąžuolinė slėgio plokštė",
  "block.minecraft.spruce_pressure_plate": "eglinė slėgio plokštė",
  "block.minecraft.birch_pressure_plate": "beržinė slėgio plokštė",
  "block.minecraft.jungle_pressure_plate": "džiunglių medžio slėgio plokštė",
  "block.minecraft.acacia_pressure_plate": "akacijos slėgio plokštė",
  "block.minecraft.dark_oak_pressure_plate": "tamsiojo ąžuolo slėgio plokštė",
  "block.minecraft.crimson_pressure_plate": "raudonio slėgio plokštė",
  "block.minecraft.warped_pressure_plate": "klaikioji slėgio plokštė",
  "block.minecraft.polished_blackstone_pressure_plate": "šlifuoto juodakmenio slėgio plokštė",
  "block.minecraft.redstone_ore": "redstouno rūda",
  "block.minecraft.redstone_torch": "redstouno deglas",
  "block.minecraft.snow": "sniegas",
  "block.minecraft.ice": "ledas",
  "block.minecraft.snow_block": "sniego blokas",
  "block.minecraft.cactus": "kaktusas",
  "block.minecraft.clay": "molis",
  "block.minecraft.jukebox": "diskų grotuvas",
  "block.minecraft.oak_fence": "ąžuolo tvora",
  "block.minecraft.spruce_fence": "eglės tvora",
  "block.minecraft.birch_fence": "beržo tvora",
  "block.minecraft.jungle_fence": "džiunglių medžio tvora",
  "block.minecraft.acacia_fence": "akacijos tvora",
  "block.minecraft.dark_oak_fence": "tamsiojo ąžuolo tvora",
  "block.minecraft.crimson_fence": "raudonio tvora",
  "block.minecraft.warped_fence": "klaikioji tvora",
  "block.minecraft.pumpkin": "moliūgas",
  "block.minecraft.carved_pumpkin": "išskobtas moliūgas",
  "block.minecraft.netherrack": "neterrakas",
  "block.minecraft.soul_sand": "sielų smėlis",
  "block.minecraft.soul_soil": "sielų dirva",
  "block.minecraft.basalt": "bazaltas",
  "block.minecraft.polished_basalt": "šlifuotas bazaltas",
  "block.minecraft.soul_torch": "sielų deglas",
  "block.minecraft.glowstone": "šviesakmenis",
  "block.minecraft.jack_o_lantern": "moliūgo žibintas",
  "block.minecraft.oak_trapdoor": "ąžuolo liukas",
  "block.minecraft.spruce_trapdoor": "eglės liukas",
  "block.minecraft.birch_trapdoor": "beržo liukas",
  "block.minecraft.jungle_trapdoor": "džiunglių medžio liukas",
  "block.minecraft.acacia_trapdoor": "akacijos liukas",
  "block.minecraft.dark_oak_trapdoor": "tamsiojo ąžuolo liukas",
  "block.minecraft.crimson_trapdoor": "raudonio liukas",
  "block.minecraft.warped_trapdoor": "klaikusis liukas",
  "block.minecraft.infested_stone": "užkrėstas akmuo",
  "block.minecraft.infested_cobblestone": "užkrėsta akmens skalda",
  "block.minecraft.infested_stone_bricks": "užkrėstos akmens plytos",
  "block.minecraft.infested_mossy_stone_bricks": "užkrėstos samanotos akmens plytos",
  "block.minecraft.infested_cracked_stone_bricks": "užkrėstos sutrūkinėjusios akmens plytos",
  "block.minecraft.infested_chiseled_stone_bricks": "užkrėstos raižytos akmens plytos",
  "block.minecraft.stone_bricks": "akmens plytos",
  "block.minecraft.mossy_stone_bricks": "samanotos akmens plytos",
  "block.minecraft.cracked_stone_bricks": "sutrūkinėjusios akmens plytos",
  "block.minecraft.chiseled_stone_bricks": "raižytos akmens plytos",
  "block.minecraft.brown_mushroom_block": "rudo grybo blokas",
  "block.minecraft.red_mushroom_block": "raudono grybo blokas",
  "block.minecraft.mushroom_stem": "grybo stiebas",
  "block.minecraft.iron_bars": "grotos",
  "block.minecraft.chain": "grandinė",
  "block.minecraft.glass_pane": "stiklo plokštė",
  "block.minecraft.melon": "arbūzas",
  "block.minecraft.vine": "vijokliai",
  "block.minecraft.oak_fence_gate": "varteliai",
  "block.minecraft.spruce_fence_gate": "eglės varteliai",
  "block.minecraft.birch_fence_gate": "beržo varteliai",
  "block.minecraft.jungle_fence_gate": "džiunglių medžio varteliai",
  "block.minecraft.acacia_fence_gate": "akacijos varteliai",
  "block.minecraft.dark_oak_fence_gate": "tamsiojo ąžuolo varteliai",
  "block.minecraft.crimson_fence_gate": "raudonio vartai",
  "block.minecraft.warped_fence_gate": "klaikieji vartai",
  "block.minecraft.brick_stairs": "plytų laiptai",
  "block.minecraft.stone_brick_stairs": "akmens plytų laiptai",
  "block.minecraft.mycelium": "grybiena",
  "block.minecraft.lily_pad": "lelijos lapas",
  "block.minecraft.nether_bricks": "neterio plytos",
  "block.minecraft.cracked_nether_bricks": "sutrūkinėjusios neterio plytos",
  "block.minecraft.chiseled_nether_bricks": "raižytos neterio plytos",
  "block.minecraft.nether_brick_fence": "neterio plytų tvora",
  "block.minecraft.nether_brick_stairs": "neterio plytų laiptai",
  "block.minecraft.enchanting_table": "kerų stalas",
  "block.minecraft.end_portal_frame": "endo portalo rėmas",
  "block.minecraft.end_stone": "endakmenis",
  "block.minecraft.end_stone_bricks": "endakmenio plytos",
  "block.minecraft.dragon_egg": "drakonės kiaušinis",
  "block.minecraft.redstone_lamp": "redstouninė lempa",
  "block.minecraft.sandstone_stairs": "smiltainio laiptai",
  "block.minecraft.emerald_ore": "smaragdo rūda",
  "block.minecraft.ender_chest": "enderio skrynia",
  "block.minecraft.tripwire_hook": "vielos kablys",
  "block.minecraft.emerald_block": "smaragdo blokas",
  "block.minecraft.spruce_stairs": "eglės laiptai",
  "block.minecraft.birch_stairs": "beržo laiptai",
  "block.minecraft.jungle_stairs": "džiunglių medžio laiptai",
  "block.minecraft.crimson_stairs": "raudonio laiptai",
  "block.minecraft.warped_stairs": "klaikieji laiptai",
  "block.minecraft.command_block": "komandos blokas",
  "block.minecraft.beacon": "švyturys",
  "block.minecraft.cobblestone_wall": "akmens skaldos siena",
  "block.minecraft.mossy_cobblestone_wall": "samanotos akmens skaldos siena",
  "block.minecraft.brick_wall": "plytų siena",
  "block.minecraft.prismarine_wall": "prismarino siena",
  "block.minecraft.red_sandstone_wall": "raudonojo smiltainio siena",
  "block.minecraft.mossy_stone_brick_wall": "samanoto akmens plytų siena",
  "block.minecraft.granite_wall": "granito siena",
  "block.minecraft.stone_brick_wall": "akmens plytų siena",
  "block.minecraft.nether_brick_wall": "neterio plytų siena",
  "block.minecraft.andesite_wall": "andezito siena",
  "block.minecraft.red_nether_brick_wall": "raudonų neterio plytų siena",
  "block.minecraft.sandstone_wall": "smiltainio siena",
  "block.minecraft.end_stone_brick_wall": "endakmenio plytų siena",
  "block.minecraft.diorite_wall": "diorito siena",
  "block.minecraft.blackstone_wall": "juodakmenio siena",
  "block.minecraft.polished_blackstone_wall": "šlifuoto juodakmenio siena",
  "block.minecraft.polished_blackstone_brick_wall": "šlifuoto juodakmenio plytų siena",
  "block.minecraft.stone_button": "akmens mygtukas",
  "block.minecraft.oak_button": "ąžuolo mygtukas",
  "block.minecraft.spruce_button": "eglės mygtukas",
  "block.minecraft.birch_button": "beržo mygtukas",
  "block.minecraft.jungle_button": "džiunglių medžio mygtukas",
  "block.minecraft.acacia_button": "akacijos mygtukas",
  "block.minecraft.dark_oak_button": "tamsiojo ąžuolo mygtukas",
  "block.minecraft.crimson_button": "raudonio mygtukas",
  "block.minecraft.warped_button": "klaikusis mygtukas",
  "block.minecraft.polished_blackstone_button": "šlifuoto juodakmenio mygtukas",
  "block.minecraft.anvil": "priekalas",
  "block.minecraft.chipped_anvil": "įdaužtas priekalas",
  "block.minecraft.damaged_anvil": "apgadintas priekalas",
  "block.minecraft.trapped_chest": "skrynia-spąstai",
  "block.minecraft.light_weighted_pressure_plate": "lengva svorinė slėgio plokštė",
  "block.minecraft.heavy_weighted_pressure_plate": "sunki svorinė slėgio plokštė",
  "block.minecraft.daylight_detector": "dienos šviesos jutiklis",
  "block.minecraft.redstone_block": "redstouno blokas",
  "block.minecraft.nether_quartz_ore": "neterio kvarco rūda",
  "block.minecraft.hopper": "piltuvas",
  "block.minecraft.chiseled_quartz_block": "raižytas kvarco blokas",
  "block.minecraft.quartz_block": "kvarco blokas",
  "block.minecraft.quartz_bricks": "kvarco plytos",
  "block.minecraft.quartz_pillar": "kvarco kolona",
  "block.minecraft.quartz_stairs": "kvarco laiptai",
  "block.minecraft.activator_rail": "aktyvuojantieji bėgiai",
  "block.minecraft.dropper": "mėtytuvas",
  "block.minecraft.white_terracotta": "balta terakota",
  "block.minecraft.orange_terracotta": "oranžinė terakota",
  "block.minecraft.magenta_terracotta": "šviesiai purpurinė terakota",
  "block.minecraft.light_blue_terracotta": "žydra terakota",
  "block.minecraft.yellow_terracotta": "geltona terakota",
  "block.minecraft.lime_terracotta": "šviesiai žalia terakota",
  "block.minecraft.pink_terracotta": "rausva terakota",
  "block.minecraft.gray_terracotta": "pilka terakota",
  "block.minecraft.light_gray_terracotta": "šviesiai pilka terakota",
  "block.minecraft.cyan_terracotta": "tamsiai žydra terakota",
  "block.minecraft.purple_terracotta": "purpurinė terakota",
  "block.minecraft.blue_terracotta": "mėlyna terakota",
  "block.minecraft.brown_terracotta": "ruda terakota",
  "block.minecraft.green_terracotta": "žalia terakota",
  "block.minecraft.red_terracotta": "raudona terakota",
  "block.minecraft.black_terracotta": "juoda terakota",
  "block.minecraft.barrier": "barjeras",
  "block.minecraft.iron_trapdoor": "geležinis liukas",
  "block.minecraft.hay_block": "šieno kupeta",
  "block.minecraft.white_carpet": "baltas kilimas",
  "block.minecraft.orange_carpet": "oranžinis kilimas",
  "block.minecraft.magenta_carpet": "šviesiai purpurinis kilimas",
  "block.minecraft.light_blue_carpet": "žydras kilimas",
  "block.minecraft.yellow_carpet": "geltonas kilimas",
  "block.minecraft.lime_carpet": "šviesiai žalias kilimas",
  "block.minecraft.pink_carpet": "rausvas kilimas",
  "block.minecraft.gray_carpet": "pilkas kilimas",
  "block.minecraft.light_gray_carpet": "šviesiai pilkas kilimas",
  "block.minecraft.cyan_carpet": "tamsiai žydras kilimas",
  "block.minecraft.purple_carpet": "purpurinis kilimas",
  "block.minecraft.blue_carpet": "mėlynas kilimas",
  "block.minecraft.brown_carpet": "rudas kilimas",
  "block.minecraft.green_carpet": "žalias kilimas",
  "block.minecraft.red_carpet": "raudonas kilimas",
  "block.minecraft.black_carpet": "juodas kilimas",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "anglies blokas",
  "block.minecraft.packed_ice": "suspaustas ledas",
  "block.minecraft.acacia_stairs": "akacijos laiptai",
  "block.minecraft.dark_oak_stairs": "tamsiojo ąžuolo laiptai",
  "block.minecraft.slime_block": "gleivių blokas",
  "block.minecraft.grass_path": "žolės takas",
  "block.minecraft.sunflower": "saulėgrąža",
  "block.minecraft.lilac": "alyva",
  "block.minecraft.rose_bush": "rožių krūmas",
  "block.minecraft.peony": "bijūnas",
  "block.minecraft.tall_grass": "aukšta žolė",
  "block.minecraft.large_fern": "didelis papartis",
  "block.minecraft.white_stained_glass": "baltas dažytas stiklas",
  "block.minecraft.orange_stained_glass": "oranžinis dažytas stiklas",
  "block.minecraft.magenta_stained_glass": "šviesiai purpurinis dažytas stiklas",
  "block.minecraft.light_blue_stained_glass": "žydras dažytas stiklas",
  "block.minecraft.yellow_stained_glass": "geltonas dažytas stiklas",
  "block.minecraft.lime_stained_glass": "šviesiai žalias dažytas stiklas",
  "block.minecraft.pink_stained_glass": "rausvas dažytas stiklas",
  "block.minecraft.gray_stained_glass": "pilkas dažytas stiklas",
  "block.minecraft.light_gray_stained_glass": "šviesiai pilkas dažytas stiklas",
  "block.minecraft.cyan_stained_glass": "tamsiai žydras dažytas stiklas",
  "block.minecraft.purple_stained_glass": "purpurinis dažytas stiklas",
  "block.minecraft.blue_stained_glass": "mėlynas dažytas stiklas",
  "block.minecraft.brown_stained_glass": "rudas dažytas stiklas",
  "block.minecraft.green_stained_glass": "žalias dažytas stiklas",
  "block.minecraft.red_stained_glass": "raudonas dažytas stiklas",
  "block.minecraft.black_stained_glass": "juodas dažytas stiklas",
  "block.minecraft.white_stained_glass_pane": "balta dažyto stiklo plokštė",
  "block.minecraft.orange_stained_glass_pane": "oranžinė dažyto stiklo plokštė",
  "block.minecraft.magenta_stained_glass_pane": "šviesiai purpurinė dažyto stiklo plokštė",
  "block.minecraft.light_blue_stained_glass_pane": "žydra dažyto stiklo plokštė",
  "block.minecraft.yellow_stained_glass_pane": "geltona dažyto stiklo plokštė",
  "block.minecraft.lime_stained_glass_pane": "šviesiai žalia dažyto stiklo plokštė",
  "block.minecraft.pink_stained_glass_pane": "rausva dažyto stiklo plokštė",
  "block.minecraft.gray_stained_glass_pane": "pilka dažyto stiklo plokštė",
  "block.minecraft.light_gray_stained_glass_pane": "šviesiai pilka dažyto stiklo plokštė",
  "block.minecraft.cyan_stained_glass_pane": "tamsiai žydra dažyto stiklo plokštė",
  "block.minecraft.purple_stained_glass_pane": "purpurinė dažyto stiklo plokštė",
  "block.minecraft.blue_stained_glass_pane": "mėlyna dažyto stiklo plokštė",
  "block.minecraft.brown_stained_glass_pane": "ruda dažyto stiklo plokštė",
  "block.minecraft.green_stained_glass_pane": "žalia dažyto stiklo plokštė",
  "block.minecraft.red_stained_glass_pane": "raudona dažyto stiklo plokštė",
  "block.minecraft.black_stained_glass_pane": "juoda dažyto stiklo plokštė",
  "block.minecraft.prismarine": "prizmarinas",
  "block.minecraft.prismarine_bricks": "prizmarino plytos",
  "block.minecraft.dark_prismarine": "tamsusis prizmarinas",
  "block.minecraft.prismarine_stairs": "prizmarino laiptai",
  "block.minecraft.prismarine_brick_stairs": "prizmarino plytų laiptai",
  "block.minecraft.dark_prismarine_stairs": "tamsiojo prizmarino laiptai",
  "block.minecraft.sea_lantern": "jūros žibintas",
  "block.minecraft.red_sandstone": "raudonasis smiltainis",
  "block.minecraft.chiseled_red_sandstone": "raižytas raudonasis smiltainis",
  "block.minecraft.cut_red_sandstone": "šlifuotas raudonasis smiltainis",
  "block.minecraft.red_sandstone_stairs": "raudonojo smiltainio laiptai",
  "block.minecraft.repeating_command_block": "besikartojantis komandos blokas",
  "block.minecraft.chain_command_block": "grandininis komandos blokas",
  "block.minecraft.magma_block": "magmos blokas",
  "block.minecraft.nether_wart_block": "neterio gumbo blokas",
  "block.minecraft.warped_wart_block": "klaikusis gumbo blokas",
  "block.minecraft.red_nether_bricks": "raudonos neterio plytos",
  "block.minecraft.bone_block": "kaulų blokas",
  "block.minecraft.structure_void": "struktūrinė tuštuma",
  "block.minecraft.observer": "stebėtojas",
  "block.minecraft.shulker_box": "šulkerio dėžė",
  "block.minecraft.white_shulker_box": "balta šulkerio dėžė",
  "block.minecraft.orange_shulker_box": "oranžinė šulkerio dėžė",
  "block.minecraft.magenta_shulker_box": "šviesiai purpurinė šulkerio dėžė",
  "block.minecraft.light_blue_shulker_box": "žydra šulkerio dėžė",
  "block.minecraft.yellow_shulker_box": "geltona šulkerio dėžė",
  "block.minecraft.lime_shulker_box": "šviesiai žalia šulkerio dėžė",
  "block.minecraft.pink_shulker_box": "rausva šulkerio dėžė",
  "block.minecraft.gray_shulker_box": "pilka šulkerio dėžė",
  "block.minecraft.light_gray_shulker_box": "šviesiai pilka šulkerio dėžė",
  "block.minecraft.cyan_shulker_box": "tamsiai žydra šulkerio dėžė",
  "block.minecraft.purple_shulker_box": "purpurinė šulkerio dėžė",
  "block.minecraft.blue_shulker_box": "mėlyna šulkerio dėžė",
  "block.minecraft.brown_shulker_box": "ruda šulkerio dėžė",
  "block.minecraft.green_shulker_box": "žalia šulkerio dėžė",
  "block.minecraft.red_shulker_box": "raudona šulkerio dėžė",
  "block.minecraft.black_shulker_box": "juoda šulkerio dėžė",
  "block.minecraft.white_glazed_terracotta": "balta glazūruota terakota",
  "block.minecraft.orange_glazed_terracotta": "oranžinė glazūruota terakota",
  "block.minecraft.magenta_glazed_terracotta": "šviesiai purpurinė glazūruota terakota",
  "block.minecraft.light_blue_glazed_terracotta": "žydra glazūruota terakota",
  "block.minecraft.yellow_glazed_terracotta": "geltona glazūruota terakota",
  "block.minecraft.lime_glazed_terracotta": "šviesiai žalia glazūruota terakota",
  "block.minecraft.pink_glazed_terracotta": "rausva glazūruota terakota",
  "block.minecraft.gray_glazed_terracotta": "pilka glazūruota terakota",
  "block.minecraft.light_gray_glazed_terracotta": "šviesiai pilka glazūruota terakota",
  "block.minecraft.cyan_glazed_terracotta": "tamsiai žydra glazūruota terakota",
  "block.minecraft.purple_glazed_terracotta": "purpurinė glazūruota terakota",
  "block.minecraft.blue_glazed_terracotta": "mėlyna glazūruota terakota",
  "block.minecraft.brown_glazed_terracotta": "ruda glazūruota terakota",
  "block.minecraft.green_glazed_terracotta": "žalia glazūruota terakota",
  "block.minecraft.red_glazed_terracotta": "raudona glazūruota terakota",
  "block.minecraft.black_glazed_terracotta": "juoda glazūruota terakota",
  "block.minecraft.white_concrete": "baltas betonas",
  "block.minecraft.orange_concrete": "oranžinis betonas",
  "block.minecraft.magenta_concrete": "šviesiai purpurinis betonas",
  "block.minecraft.light_blue_concrete": "žydras betonas",
  "block.minecraft.yellow_concrete": "geltonas betonas",
  "block.minecraft.lime_concrete": "šviesiai žalias betonas",
  "block.minecraft.pink_concrete": "rausvas betonas",
  "block.minecraft.gray_concrete": "pilkas betonas",
  "block.minecraft.light_gray_concrete": "šviesiai pilkas betonas",
  "block.minecraft.cyan_concrete": "tamsiai žydras betonas",
  "block.minecraft.purple_concrete": "purpurinis betonas",
  "block.minecraft.blue_concrete": "mėlynas betonas",
  "block.minecraft.brown_concrete": "rudas betonas",
  "block.minecraft.green_concrete": "žalias betonas",
  "block.minecraft.red_concrete": "raudonas betonas",
  "block.minecraft.black_concrete": "juodas betonas",
  "block.minecraft.white_concrete_powder": "baltas cementas",
  "block.minecraft.orange_concrete_powder": "oranžinis cementas",
  "block.minecraft.magenta_concrete_powder": "šviesiai purpurinis cementas",
  "block.minecraft.light_blue_concrete_powder": "žydras cementas",
  "block.minecraft.yellow_concrete_powder": "geltonas cementas",
  "block.minecraft.lime_concrete_powder": "šviesiai žalias cementas",
  "block.minecraft.pink_concrete_powder": "rausvas cementas",
  "block.minecraft.gray_concrete_powder": "pilkas cementas",
  "block.minecraft.light_gray_concrete_powder": "šviesiai pilkas cementas",
  "block.minecraft.cyan_concrete_powder": "tamsiai žydras cementas",
  "block.minecraft.purple_concrete_powder": "purpurinis cementas",
  "block.minecraft.blue_concrete_powder": "mėlynas cementas",
  "block.minecraft.brown_concrete_powder": "rudas cementas",
  "block.minecraft.green_concrete_powder": "žalias cementas",
  "block.minecraft.red_concrete_powder": "raudonas cementas",
  "block.minecraft.black_concrete_powder": "juodas cementas",
  "block.minecraft.turtle_egg": "vėžlio kiaušinis",
  "block.minecraft.dead_tube_coral_block": "negyvas vamzdinis koralo blokas",
  "block.minecraft.dead_brain_coral_block": "negyvas smegeninis koralo blokas",
  "block.minecraft.dead_bubble_coral_block": "negyvas burbulinis koralo blokas",
  "block.minecraft.dead_fire_coral_block": "negyvas ugninis koralo blokas",
  "block.minecraft.dead_horn_coral_block": "negyvas raguotas koralo blokas",
  "block.minecraft.tube_coral_block": "vamzdinis koralo blokas",
  "block.minecraft.brain_coral_block": "smegeninis koralo blokas",
  "block.minecraft.bubble_coral_block": "burbulinis koralo blokas",
  "block.minecraft.fire_coral_block": "ugninis koralo blokas",
  "block.minecraft.horn_coral_block": "raguotas koralo blokas",
  "block.minecraft.tube_coral": "vamzdinis koralas",
  "block.minecraft.brain_coral": "smegeninis koralas",
  "block.minecraft.bubble_coral": "burbulinis koralas",
  "block.minecraft.fire_coral": "ugninis koralas",
  "block.minecraft.horn_coral": "raguotas koralas",
  "block.minecraft.dead_brain_coral": "negyvas smegeninis koralas",
  "block.minecraft.dead_bubble_coral": "negyvas burbulinis koralas",
  "block.minecraft.dead_fire_coral": "negyvas ugninis koralas",
  "block.minecraft.dead_horn_coral": "negyvas raguotas koralas",
  "block.minecraft.dead_tube_coral": "negyvas vamzdinis koralas",
  "block.minecraft.tube_coral_fan": "vamzdinis koralas vėduoklė",
  "block.minecraft.brain_coral_fan": "smegeninis koralas vėduoklė",
  "block.minecraft.bubble_coral_fan": "burbulinis koralas vėduoklė",
  "block.minecraft.fire_coral_fan": "ugninis koralas vėduoklė",
  "block.minecraft.horn_coral_fan": "raguotas koralas vėduoklė",
  "block.minecraft.dead_tube_coral_fan": "negyvas vamzdinis koralas vėduoklė",
  "block.minecraft.dead_brain_coral_fan": "negyvas smegeninis koralas vėduoklė",
  "block.minecraft.dead_bubble_coral_fan": "negyvas burbulinis koralas vėduoklė",
  "block.minecraft.dead_fire_coral_fan": "negyvas ugninis koralas vėduoklė",
  "block.minecraft.dead_horn_coral_fan": "negyvas raguotas koralas vėduoklė",
  "block.minecraft.blue_ice": "mėlynasis ledas",
  "block.minecraft.conduit": "jūros kanalas",
  "block.minecraft.polished_granite_stairs": "šlifuoto granito laiptai",
  "block.minecraft.smooth_red_sandstone_stairs": "lygaus raudonojo smiltainio laiptai",
  "block.minecraft.mossy_stone_brick_stairs": "samanotų akmenų plytų laiptai",
  "block.minecraft.polished_diorite_stairs": "šlifuoto diorito laiptai",
  "block.minecraft.mossy_cobblestone_stairs": "samanotos akmens skaldos laiptai",
  "block.minecraft.end_stone_brick_stairs": "endakmenio plytų laiptai",
  "block.minecraft.stone_stairs": "akmens laiptai",
  "block.minecraft.smooth_sandstone_stairs": "lygaus smiltainio laiptai",
  "block.minecraft.smooth_quartz_stairs": "lygaus kvarco laiptai",
  "block.minecraft.granite_stairs": "granito laiptai",
  "block.minecraft.andesite_stairs": "andezito laiptai",
  "block.minecraft.red_nether_brick_stairs": "raudonų neterio plytų laiptai",
  "block.minecraft.polished_andesite_stairs": "šlifuoto andezito laiptai",
  "block.minecraft.diorite_stairs": "diorito laiptai",
  "block.minecraft.polished_granite_slab": "šlifuoto granito pusblokis",
  "block.minecraft.smooth_red_sandstone_slab": "lygaus raudonojo smiltainio pusblokis",
  "block.minecraft.mossy_stone_brick_slab": "samanotų akmenų plytų pusblokis",
  "block.minecraft.polished_diorite_slab": "šlifuoto diorito pusblokis",
  "block.minecraft.mossy_cobblestone_slab": "samanotos akmens skaldos pusblokis",
  "block.minecraft.end_stone_brick_slab": "endakmenio plytų pusblokis",
  "block.minecraft.smooth_sandstone_slab": "lygaus smiltainio pusblokis",
  "block.minecraft.smooth_quartz_slab": "lygaus kvarco pusblokis",
  "block.minecraft.granite_slab": "granito pusblokis",
  "block.minecraft.andesite_slab": "andezito pusblokis",
  "block.minecraft.red_nether_brick_slab": "raudonų neterio plytų pusblokis",
  "block.minecraft.polished_andesite_slab": "šlifuoto andezito pusblokis",
  "block.minecraft.diorite_slab": "diorito pusblokis",
  "block.minecraft.scaffolding": "pastoliai",
  "block.minecraft.iron_door": "geležinės durys",
  "block.minecraft.oak_door": "ąžuolo durys",
  "block.minecraft.spruce_door": "eglės durys",
  "block.minecraft.birch_door": "beržo durys",
  "block.minecraft.jungle_door": "džiunglių medžio durys",
  "block.minecraft.acacia_door": "akacijos durys",
  "block.minecraft.dark_oak_door": "tamsiojo ąžuolo durys",
  "block.minecraft.crimson_door": "raudonio durys",
  "block.minecraft.warped_door": "klaikiosios durys",
  "block.minecraft.repeater": "redstouno kartotuvas",
  "block.minecraft.comparator": "redstouno komparatorius",
  "block.minecraft.structure_block": "struktūros blokas",
  "block.minecraft.jigsaw": "dėlionės blokas",
  "item.minecraft.turtle_helmet": "vėžlio kiautas□□kai ant galvos:□+2 šarvai",
  "item.minecraft.scute": "kiautas",
  "item.minecraft.iron_shovel": "geležinis kastuvas□□kai pagrindinėje rankoje:□+3.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.iron_pickaxe": "geležinis kirtiklis□□kai pagrindinėje rankoje:□+3 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.iron_axe": "geležinis kirvis□□kai pagrindinėje rankoje:□+8 puolimo žala□-3.1 puolimo greitis",
  "item.minecraft.flint_and_steel": "titnagas ir geležis",
  "item.minecraft.apple": "obuolys",
  "item.minecraft.bow": "lankas",
  "item.minecraft.arrow": "strėlė",
  "item.minecraft.coal": "anglis",
  "item.minecraft.charcoal": "medžio anglis",
  "item.minecraft.diamond": "deimantas",
  "item.minecraft.iron_ingot": "geležies liejinys",
  "item.minecraft.gold_ingot": "aukso liejinys",
  "item.minecraft.netherite_ingot": "neterito liejinys",
  "item.minecraft.netherite_scrap": "neterito atraiža",
  "item.minecraft.iron_sword": "geležinis kardas□□kai pagrindinėje rankoje:□+5 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.wooden_sword": "medinis kardas□□kai pagrindinėje rankoje:□+3 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.wooden_shovel": "medinis kastuvas□□kai pagrindinėje rankoje:□+1.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.wooden_pickaxe": "medinis kirtiklis□□kai pagrindinėje rankoje:□+1 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.wooden_axe": "medinis kirvis□□kai pagrindinėje rankoje:□+6 puolimo žala□-3.2 puolimo greitis",
  "item.minecraft.stone_sword": "akmeninis kardas□□kai pagrindinėje rankoje:□+4 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.stone_shovel": "akmeninis kastuvas□□kai pagrindinėje rankoje:□+2.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.stone_pickaxe": "akmeninis kirtiklis□□kai pagrindinėje rankoje:□+2 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.stone_axe": "akmeninis kirvis□□kai pagrindinėje rankoje:□+8 puolimo žala□-3.2 puolimo greitis",
  "item.minecraft.diamond_sword": "deimantinis kardas□□kai pagrindinėje rankoje:□+6 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.diamond_shovel": "deimantinis kastuvas□□kai pagrindinėje rankoje:□+4.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.diamond_pickaxe": "deimantinis kirtiklis□□kai pagrindinėje rankoje:□+4 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.diamond_axe": "deimantinis kirvis□□kai pagrindinėje rankoje:□+8 puolimo žala□-3 puolimo greitis",
  "item.minecraft.stick": "pagaliukas",
  "item.minecraft.bowl": "dubuo",
  "item.minecraft.mushroom_stew": "grybų troškinys",
  "item.minecraft.golden_sword": "auksinis kardas□□kai pagrindinėje rankoje:□+3 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.golden_shovel": "auksinis kastuvas□□kai pagrindinėje rankoje:□+1.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.golden_pickaxe": "auksinis kirtiklis□□kai pagrindinėje rankoje:□+1 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.golden_axe": "auksinis kirvis□□kai pagrindinėje rankoje:□+6 puolimo žala□-3 puolimo greitis",
  "item.minecraft.netherite_sword": "neteritinis kardas□□kai pagrindinėje rankoje:□+7 puolimo žala□-2.4 puolimo greitis",
  "item.minecraft.netherite_shovel": "neteritinis kastuvas□□kai pagrindinėje rankoje:□+5.5 puolimo žala□-3 puolimo greitis",
  "item.minecraft.netherite_pickaxe": "neteritinis kirtiklis□□kai pagrindinėje rankoje:□+5 puolimo žala□-2.8 puolimo greitis",
  "item.minecraft.netherite_axe": "neteritinis kirvis□□kai pagrindinėje rankoje:□+9 puolimo žala□-3 puolimo greitis",
  "item.minecraft.string": "siūlas",
  "item.minecraft.feather": "plunksna",
  "item.minecraft.gunpowder": "parakas",
  "item.minecraft.wooden_hoe": "medinis kaplys□□kai pagrindinėje rankoje:□-3 puolimo greitis",
  "item.minecraft.stone_hoe": "akmeninis kaplys□□kai pagrindinėje rankoje:□-2 puolimo greitis",
  "item.minecraft.iron_hoe": "geležinis kaplys□□kai pagrindinėje rankoje:□-1 puolimo greitis",
  "item.minecraft.diamond_hoe": "deimantinis kaplys□□kai pagrindinėje rankoje:",
  "item.minecraft.golden_hoe": "auksinis kaplys□□kai pagrindinėje rankoje:□-3 puolimo greitis",
  "item.minecraft.netherite_hoe": "neteritinis kaplys□□kai pagrindinėje rankoje:",
  "item.minecraft.wheat_seeds": "kviečių sėklos",
  "item.minecraft.wheat": "kviečiai",
  "item.minecraft.bread": "duona",
  "item.minecraft.leather_helmet": "odinė kepurė□□kai ant galvos:□+1 šarvai",
  "item.minecraft.leather_chestplate": "odinė tunika□□kai ant kūno:□+3 šarvai",
  "item.minecraft.leather_leggings": "odinės kelnės□□kai ant kojų:□+2 šarvai",
  "item.minecraft.leather_boots": "odiniai batai□□kai ant pėdų:□+1 šarvai",
  "item.minecraft.chainmail_helmet": "grandininis šalmas□□kai ant galvos:□+2 šarvai",
  "item.minecraft.chainmail_chestplate": "grandininis antkrūtinis□□kai ant kūno:□+5 šarvai",
  "item.minecraft.chainmail_leggings": "grandininės kelnės□□kai ant kojų:□+4 šarvai",
  "item.minecraft.chainmail_boots": "grandininiai batai□□kai ant pėdų:□+1 šarvai",
  "item.minecraft.iron_helmet": "geležinis šalmas□□kai ant galvos:□+2 šarvai",
  "item.minecraft.iron_chestplate": "geležinis antkrūtinis□□kai ant kūno:□+6 šarvai",
  "item.minecraft.iron_leggings": "geležinės kelnės□□kai ant kojų:□+5 šarvai",
  "item.minecraft.iron_boots": "geležiniai batai□□kai ant pėdų:□+2 šarvai",
  "item.minecraft.diamond_helmet": "deimantinis šalmas□□kai ant galvos:□+3 šarvai□+2 šarvų kietumas",
  "item.minecraft.diamond_chestplate": "deimantinis antkrūtinis□□kai ant kūno:□+8 šarvai□+2 šarvų kietumas",
  "item.minecraft.diamond_leggings": "deimantinės kelnės□□kai ant kojų:□+6 šarvai□+2 šarvų kietumas",
  "item.minecraft.diamond_boots": "deimantiniai batai□□kai ant pėdų:□+3 šarvai□+2 šarvų kietumas",
  "item.minecraft.golden_helmet": "auksinis šalmas□□kai ant galvos:□+2 šarvai",
  "item.minecraft.golden_chestplate": "auksinis antkrūtinis□□kai ant kūno:□+5 šarvai",
  "item.minecraft.golden_leggings": "auksinės kelnės□□kai ant kojų:□+3 šarvai",
  "item.minecraft.golden_boots": "auksiniai batai□□kai ant pėdų:□+1 šarvai",
  "item.minecraft.netherite_helmet": "neteritinis šalmas□□kai ant galvos:□+3 šarvai□+3 šarvų kietumas□+1 atsparumas smūgiams",
  "item.minecraft.netherite_chestplate": "neteritinis antkrūtinis□□kai ant kūno:□+8 šarvai□+3 šarvų kietumas□+1 atsparumas smūgiams",
  "item.minecraft.netherite_leggings": "neteritinės kelnės□□kai ant kojų:□+6 šarvai□+3 šarvų kietumas□+1 atsparumas smūgiams",
  "item.minecraft.netherite_boots": "neteritiniai batai□□kai ant pėdų:□+3 šarvai□+3 šarvų kietumas□+1 atsparumas smūgiams",
  "item.minecraft.flint": "titnagas",
  "item.minecraft.porkchop": "žalia kiauliena",
  "item.minecraft.cooked_porkchop": "kepta kiauliena",
  "item.minecraft.painting": "paveikslas",
  "item.minecraft.golden_apple": "auksinis obuolys",
  "item.minecraft.enchanted_golden_apple": "užkerėtas auksinis obuolys",
  "block.minecraft.oak_sign": "ąžuolinis ženklas",
  "block.minecraft.spruce_sign": "eglės ženklas",
  "block.minecraft.birch_sign": "beržo ženklas",
  "block.minecraft.jungle_sign": "džiunglių medžio ženklas",
  "block.minecraft.acacia_sign": "akacijos ženklas",
  "block.minecraft.dark_oak_sign": "tamsiojo ąžuolo ženklas",
  "block.minecraft.crimson_sign": "raudonio ženklas",
  "block.minecraft.warped_sign": "klaikusis ženklas",
  "item.minecraft.bucket": "kibiras",
  "item.minecraft.water_bucket": "vandens kibiras",
  "item.minecraft.lava_bucket": "lavos kibiras",
  "item.minecraft.minecart": "vagonėlis",
  "item.minecraft.saddle": "balnas",
  "item.minecraft.redstone": "redstouno dulkės",
  "item.minecraft.snowball": "sniego gniūžtė",
  "item.minecraft.oak_boat": "ąžuolo valtis",
  "item.minecraft.leather": "oda",
  "item.minecraft.milk_bucket": "pieno kibiras",
  "item.minecraft.pufferfish_bucket": "pūsliažuvė kibire",
  "item.minecraft.salmon_bucket": "lašiša kibire",
  "item.minecraft.cod_bucket": "menkė kibire",
  "item.minecraft.tropical_fish_bucket": "tropinė žuvis kibire",
  "item.minecraft.brick": "plyta",
  "item.minecraft.clay_ball": "molio kamuoliukas",
  "block.minecraft.dried_kelp_block": "džiovintų rudadumblių blokas",
  "item.minecraft.paper": "popierius",
  "item.minecraft.book": "knyga",
  "item.minecraft.slime_ball": "gleivių kamuolėlis",
  "item.minecraft.chest_minecart": "vagonėlis su skrynia",
  "item.minecraft.furnace_minecart": "vagonėlis su krosnimi",
  "item.minecraft.egg": "kiaušinis",
  "item.minecraft.compass": "kompasas",
  "item.minecraft.fishing_rod": "meškerė",
  "item.minecraft.clock": "laikrodis",
  "item.minecraft.glowstone_dust": "šviesakmenio dulkės",
  "item.minecraft.cod": "žalia menkė",
  "item.minecraft.salmon": "žalia lašiša",
  "item.minecraft.tropical_fish": "tropinė žuvis",
  "item.minecraft.pufferfish": "pūsliažuvė",
  "item.minecraft.cooked_cod": "kepta menkė",
  "item.minecraft.cooked_salmon": "kepta lašiša",
  "item.minecraft.ink_sac": "rašalo pūslė",
  "item.minecraft.red_dye": "raudoni dažai",
  "item.minecraft.green_dye": "žali dažai",
  "item.minecraft.cocoa_beans": "kakavos pupelės",
  "item.minecraft.lapis_lazuli": "lazuritas",
  "item.minecraft.purple_dye": "purpuriniai dažai",
  "item.minecraft.cyan_dye": "tamsiai žydri dažai",
  "item.minecraft.light_gray_dye": "šviesiai pilki dažai",
  "item.minecraft.gray_dye": "pilki dažai",
  "item.minecraft.pink_dye": "rausvi dažai",
  "item.minecraft.lime_dye": "šviesiai žali dažai",
  "item.minecraft.yellow_dye": "geltoni dažai",
  "item.minecraft.light_blue_dye": "žydri dažai",
  "item.minecraft.magenta_dye": "šviesiai purpuriniai dažai",
  "item.minecraft.orange_dye": "oranžiniai dažai",
  "item.minecraft.bone_meal": "kaulų miltai",
  "item.minecraft.blue_dye": "mėlyni dažai",
  "item.minecraft.brown_dye": "rudi dažai",
  "item.minecraft.black_dye": "juodi dažai",
  "item.minecraft.white_dye": "balti dažai",
  "item.minecraft.bone": "kaulas",
  "item.minecraft.sugar": "cukrus",
  "block.minecraft.cake": "tortas",
  "block.minecraft.white_bed": "balta lova",
  "block.minecraft.orange_bed": "oranžinė lova",
  "block.minecraft.magenta_bed": "šviesiai purpurinė lova",
  "block.minecraft.light_blue_bed": "žydra lova",
  "block.minecraft.yellow_bed": "geltona lova",
  "block.minecraft.lime_bed": "šviesiai žalia lova",
  "block.minecraft.pink_bed": "rausva lova",
  "block.minecraft.gray_bed": "pilka lova",
  "block.minecraft.light_gray_bed": "šviesiai pilka lova",
  "block.minecraft.cyan_bed": "tamsiai žydra lova",
  "block.minecraft.purple_bed": "purpurinė lova",
  "block.minecraft.blue_bed": "mėlyna lova",
  "block.minecraft.brown_bed": "ruda lova",
  "block.minecraft.green_bed": "žalia lova",
  "block.minecraft.red_bed": "raudona lova",
  "block.minecraft.black_bed": "juoda lova",
  "item.minecraft.cookie": "sausainis",
  "item.minecraft.filled_map": "žemėlapis□#0",
  "item.minecraft.shears": "žirklės",
  "item.minecraft.melon_slice": "arbūzo skiltelė",
  "item.minecraft.dried_kelp": "džiovinti rudadumbliai",
  "item.minecraft.pumpkin_seeds": "moliūgų sėklos",
  "item.minecraft.melon_seeds": "arbūzų sėklos",
  "item.minecraft.beef": "žalia jautiena",
  "item.minecraft.cooked_beef": "kepsnys",
  "item.minecraft.chicken": "žalia vištiena",
  "item.minecraft.cooked_chicken": "kepta vištiena",
  "item.minecraft.rotten_flesh": "supuvusi mėsa",
  "item.minecraft.ender_pearl": "enderio perlas",
  "item.minecraft.blaze_rod": "liepsnos strypas",
  "item.minecraft.ghast_tear": "gasto ašara",
  "item.minecraft.gold_nugget": "aukso grynuolis",
  "item.minecraft.nether_wart": "neterio gumbas",
  "item.minecraft.potion": "nepagaminamas eliksyras□be poveikio",
  "item.minecraft.glass_bottle": "stiklinis buteliukas",
  "item.minecraft.spider_eye": "voro akis",
  "item.minecraft.fermented_spider_eye": "rauginta voro akis",
  "item.minecraft.blaze_powder": "liepsnos pudra",
  "item.minecraft.magma_cream": "magmos kremas",
  "block.minecraft.brewing_stand": "eliksyrų stovas",
  "block.minecraft.cauldron": "katilas",
  "item.minecraft.ender_eye": "enderio akis",
  "item.minecraft.glistering_melon_slice": "žvilganti arbūzo skiltelė",
  "item.minecraft.bat_spawn_egg": "suformuoto šikšnosparnio kiaušinis",
  "item.minecraft.bee_spawn_egg": "suformuotos bitės kiaušinis",
  "item.minecraft.blaze_spawn_egg": "suformuotos liepsnos kiaušinis",
  "item.minecraft.cat_spawn_egg": "suformuotos katės kiaušinis",
  "item.minecraft.cave_spider_spawn_egg": "suformuoto urvinio voro kiaušinis",
  "item.minecraft.chicken_spawn_egg": "suformuotos vištos kiaušinis",
  "item.minecraft.cod_spawn_egg": "suformuotos menkės kiaušinis",
  "item.minecraft.cow_spawn_egg": "suformuotos karvės kiaušinis",
  "item.minecraft.creeper_spawn_egg": "suformuoto kryperio kiaušinis",
  "item.minecraft.dolphin_spawn_egg": "suformuoto delfino kiaušinis",
  "item.minecraft.donkey_spawn_egg": "suformuoto asilo kiaušinis",
  "item.minecraft.drowned_spawn_egg": "suformuoto skenduolio kiaušinis",
  "item.minecraft.elder_guardian_spawn_egg": "suformuoto didžiojo gelmių sargo kiaušinis",
  "item.minecraft.enderman_spawn_egg": "suformuoto endermeno kiaušinis",
  "item.minecraft.endermite_spawn_egg": "suformuoto endermaito kiaušinis",
  "item.minecraft.evoker_spawn_egg": "suformuoto šamano kiaušinis",
  "item.minecraft.fox_spawn_egg": "suformuotos lapės kiaušinis",
  "item.minecraft.ghast_spawn_egg": "suformuoto gasto kiaušinis",
  "item.minecraft.guardian_spawn_egg": "suformuoto gelmių sargo kiaušinis",
  "item.minecraft.hoglin_spawn_egg": "suformuoto hoglino kiaušinis",
  "item.minecraft.horse_spawn_egg": "suformuoto arklio kiaušinis",
  "item.minecraft.husk_spawn_egg": "suformuoto sudžiūvėlio kiaušinis",
  "item.minecraft.llama_spawn_egg": "suformuotos lamos kiaušinis",
  "item.minecraft.magma_cube_spawn_egg": "suformuoto magmos kubo kiaušinis",
  "item.minecraft.mooshroom_spawn_egg": "suformuotos mūšrumos kiaušinis",
  "item.minecraft.mule_spawn_egg": "suformuoto mulo kiaušinis",
  "item.minecraft.ocelot_spawn_egg": "suformuoto oceloto kiaušinis",
  "item.minecraft.panda_spawn_egg": "suformuotos pandos kiaušinis",
  "item.minecraft.parrot_spawn_egg": "suformuotos papūgos kiaušinis",
  "item.minecraft.phantom_spawn_egg": "suformuoto fantomo kiaušinis",
  "item.minecraft.pig_spawn_egg": "suformuotos kiaulės kiaušinis",
  "item.minecraft.piglin_spawn_egg": "suformuoto piglino kiaušinis",
  "item.minecraft.pillager_spawn_egg": "suformuoto plėšiko kiaušinis",
  "item.minecraft.polar_bear_spawn_egg": "suformuoto baltojo lokio kiaušinis",
  "item.minecraft.pufferfish_spawn_egg": "suformuotos pūsliažuvės kiaušinis",
  "item.minecraft.rabbit_spawn_egg": "suformuoto triušio kiaušinis",
  "item.minecraft.ravager_spawn_egg": "suformuoto siaubūno kiaušinis",
  "item.minecraft.salmon_spawn_egg": "suformuotos lašišos kiaušinis",
  "item.minecraft.sheep_spawn_egg": "suformuotos avies kiaušinis",
  "item.minecraft.shulker_spawn_egg": "suformuoto šulkerio kiaušinis",
  "item.minecraft.silverfish_spawn_egg": "suformuoto žvyninuko kiaušinis",
  "item.minecraft.skeleton_spawn_egg": "suformuoto skeleto kiaušinis",
  "item.minecraft.skeleton_horse_spawn_egg": "suformuoto skeleto arklio kiaušinis",
  "item.minecraft.slime_spawn_egg": "suformuoto gleiviaus kiaušinis",
  "item.minecraft.spider_spawn_egg": "suformuoto voro kiaušinis",
  "item.minecraft.squid_spawn_egg": "suformuoto kalmaro kiaušinis",
  "item.minecraft.stray_spawn_egg": "suformuoto klajūno kiaušinis",
  "item.minecraft.strider_spawn_egg": "suformuoto ilgažingsnio kiaušinis",
  "item.minecraft.trader_llama_spawn_egg": "suformuotos pirklio lamos kiaušinis",
  "item.minecraft.tropical_fish_spawn_egg": "suformuotos tropinės žuvies kiaušinis",
  "item.minecraft.turtle_spawn_egg": "suformuoto vėžlio kiaušinis",
  "item.minecraft.vex_spawn_egg": "suformuotos vėlės kiaušinis",
  "item.minecraft.villager_spawn_egg": "suformuoto kaimiečio kiaušinis",
  "item.minecraft.vindicator_spawn_egg": "suformuoto vindikatoriaus kiaušinis",
  "item.minecraft.wandering_trader_spawn_egg": "suformuoto klajojančio pirklio kiaušinis",
  "item.minecraft.witch_spawn_egg": "suformuotos raganos kiaušinis",
  "item.minecraft.wither_skeleton_spawn_egg": "suformuoto viterio skeleto kiaušinis",
  "item.minecraft.wolf_spawn_egg": "suformuoto vilko kiaušinis",
  "item.minecraft.zoglin_spawn_egg": "suformuoto zoglino kiaušinis",
  "item.minecraft.zombie_spawn_egg": "suformuoto zombio kiaušinis",
  "item.minecraft.zombie_horse_spawn_egg": "suformuoto zombio arklio kiaušinis",
  "item.minecraft.zombie_villager_spawn_egg": "suformuoto zombio kaimiečio kiaušinis",
  "item.minecraft.zombified_piglin_spawn_egg": "suformuoto suzombinto piglino kiaušinis",
  "item.minecraft.experience_bottle": "patirties buteliukas",
  "item.minecraft.fire_charge": "ugnies kamuolys",
  "item.minecraft.writable_book": "knyga ir plunksna",
  "item.minecraft.written_book": "prirašyta knyga",
  "item.minecraft.emerald": "smaragdas",
  "item.minecraft.item_frame": "rėmelis",
  "block.minecraft.flower_pot": "vazonas",
  "item.minecraft.carrot": "morka",
  "item.minecraft.potato": "bulvė",
  "item.minecraft.baked_potato": "kepta bulvė",
  "item.minecraft.poisonous_potato": "nuodinga bulvė",
  "item.minecraft.map": "tuščias žemėlapis",
  "item.minecraft.golden_carrot": "auksinė morka",
  "block.minecraft.skeleton_skull": "skeleto kaukolė",
  "block.minecraft.wither_skeleton_skull": "viterio skeleto kaukolė",
  "block.minecraft.player_head": "žaidėjo galva",
  "block.minecraft.zombie_head": "zombio galva",
  "block.minecraft.creeper_head": "kryperio galva",
  "block.minecraft.dragon_head": "drakonės galva",
  "item.minecraft.carrot_on_a_stick": "morka ant pagaliuko",
  "item.minecraft.warped_fungus_on_a_stick": "klaikusis grybas ant pagaliuko",
  "item.minecraft.nether_star": "neterio žvaigždė",
  "item.minecraft.pumpkin_pie": "moliūgų pyragas",
  "item.minecraft.firework_rocket": "fejerverkas",
  "item.minecraft.firework_star": "fejerverko žvaigždė",
  "item.minecraft.enchanted_book": "užkerėta knyga",
  "item.minecraft.nether_brick": "neterio plytos",
  "item.minecraft.quartz": "neterio kvarcas",
  "item.minecraft.tnt_minecart": "vagonėlis su tnt",
  "item.minecraft.hopper_minecart": "vagonėlis su piltuvu",
  "item.minecraft.prismarine_shard": "prizmarino skeveldra",
  "item.minecraft.prismarine_crystals": "prizmarino kristalai",
  "item.minecraft.rabbit": "žalias triušis",
  "item.minecraft.cooked_rabbit": "keptas triušis",
  "item.minecraft.rabbit_stew": "triušienos troškinys",
  "item.minecraft.rabbit_foot": "triušio pėda",
  "item.minecraft.rabbit_hide": "triušio kailis",
  "item.minecraft.armor_stand": "šarvų stovas",
  "item.minecraft.iron_horse_armor": "geležiniai arklio šarvai",
  "item.minecraft.golden_horse_armor": "auksiniai arklio šarvai",
  "item.minecraft.diamond_horse_armor": "deimantiniai arklio šarvai",
  "item.minecraft.leather_horse_armor": "odiniai arklio šarvai",
  "item.minecraft.lead": "pavadėlis",
  "item.minecraft.name_tag": "vardo žymeklis",
  "item.minecraft.command_block_minecart": "vagonėlis su komandos bloku",
  "item.minecraft.mutton": "žalia aviena",
  "item.minecraft.cooked_mutton": "kepta aviena",
  "block.minecraft.white_banner": "balta vėliava",
  "block.minecraft.orange_banner": "oranžinė vėliava",
  "block.minecraft.magenta_banner": "šviesiai purpurinė vėliava",
  "block.minecraft.light_blue_banner": "žydra vėliava",
  "block.minecraft.yellow_banner": "geltona vėliava",
  "block.minecraft.lime_banner": "šviesiai žalia vėliava",
  "block.minecraft.pink_banner": "rausva vėliava",
  "block.minecraft.gray_banner": "pilka vėliava",
  "block.minecraft.light_gray_banner": "šviesiai pilka vėliava",
  "block.minecraft.cyan_banner": "tamsiai žydra vėliava",
  "block.minecraft.purple_banner": "purpurinė vėliava",
  "block.minecraft.blue_banner": "mėlyna vėliava",
  "block.minecraft.brown_banner": "ruda vėliava",
  "block.minecraft.green_banner": "žalia vėliava",
  "block.minecraft.red_banner": "raudona vėliava",
  "block.minecraft.black_banner": "juoda vėliava",
  "item.minecraft.end_crystal": "endo kristalas",
  "item.minecraft.chorus_fruit": "koruso vaisius",
  "item.minecraft.popped_chorus_fruit": "spragintas koruso vaisius",
  "item.minecraft.beetroot": "burokėlis",
  "item.minecraft.beetroot_seeds": "burokėlių sėklos",
  "item.minecraft.beetroot_soup": "barščiai",
  "item.minecraft.dragon_breath": "drakonės dvelksmas",
  "item.minecraft.splash_potion": "mėtomas nepagaminamas eliksyras□be poveikio",
  "item.minecraft.spectral_arrow": "auros strėlė",
  "item.minecraft.tipped_arrow": "nepagaminama patepta strėlė□be poveikio",
  "item.minecraft.lingering_potion": "garuojantis nepagaminamas eliksyras□be poveikio",
  "item.minecraft.shield": "skydas",
  "item.minecraft.elytra": "sparnai",
  "item.minecraft.spruce_boat": "eglės valtis",
  "item.minecraft.birch_boat": "beržo valtis",
  "item.minecraft.jungle_boat": "džiunglių medžio valtis",
  "item.minecraft.acacia_boat": "akacijos valtis",
  "item.minecraft.dark_oak_boat": "tamsiojo ąžuolo valtis",
  "item.minecraft.totem_of_undying": "nemirtingumo totemas",
  "item.minecraft.shulker_shell": "šulkerio kiautas",
  "item.minecraft.iron_nugget": "geležies grynuolis",
  "item.minecraft.knowledge_book": "žinių knyga",
  "item.minecraft.debug_stick": "derinimo pagaliukas",
  "item.minecraft.music_disc_13": "muzikos diskas□c418 - 13",
  "item.minecraft.music_disc_cat": "muzikos diskas□c418 - cat",
  "item.minecraft.music_disc_blocks": "muzikos diskas□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muzikos diskas□c418 - chirp",
  "item.minecraft.music_disc_far": "muzikos diskas□c418 - far",
  "item.minecraft.music_disc_mall": "muzikos diskas□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muzikos diskas□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muzikos diskas□c418 - stal",
  "item.minecraft.music_disc_strad": "muzikos diskas□c418 - strad",
  "item.minecraft.music_disc_ward": "muzikos diskas□c418 - ward",
  "item.minecraft.music_disc_11": "muzikos diskas□c418 - 11",
  "item.minecraft.music_disc_wait": "muzikos diskas□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muzikos diskas□lena rainia - pigstep",
  "item.minecraft.trident": "trišakis□□kai pagrindinėje rankoje:□+8 puolimo žala□-2.9 puolimo greitis",
  "item.minecraft.phantom_membrane": "fantomo membrana",
  "item.minecraft.nautilus_shell": "nautilo moliusko kiautas",
  "item.minecraft.heart_of_the_sea": "jūros širdis",
  "item.minecraft.crossbow": "arbaletas",
  "item.minecraft.suspicious_stew": "įtartinas troškinys",
  "block.minecraft.loom": "staklės",
  "item.minecraft.flower_banner_pattern": "vėliavos raštas□gėlė",
  "item.minecraft.creeper_banner_pattern": "vėliavos raštas□kryperio veidas",
  "item.minecraft.skull_banner_pattern": "vėliavos raštas□kaukolė",
  "item.minecraft.mojang_banner_pattern": "vėliavos raštas□dalykas",
  "item.minecraft.globe_banner_pattern": "vėliavos raštas□gaublys",
  "item.minecraft.piglin_banner_pattern": "vėliavos raštas□šnipas",
  "block.minecraft.composter": "komposteris",
  "block.minecraft.barrel": "statinė",
  "block.minecraft.smoker": "rūkykla",
  "block.minecraft.blast_furnace": "aukštakrosnė",
  "block.minecraft.cartography_table": "kartografijos stalas",
  "block.minecraft.fletching_table": "lankininkų stalas",
  "block.minecraft.grindstone": "tekėlas",
  "block.minecraft.lectern": "pultas",
  "block.minecraft.smithing_table": "kalvio stalas",
  "block.minecraft.stonecutter": "akmens pjaustyklė",
  "block.minecraft.bell": "varpas",
  "block.minecraft.lantern": "žibintas",
  "block.minecraft.soul_lantern": "sielų žibintas",
  "item.minecraft.sweet_berries": "saldžiosios uogos",
  "block.minecraft.campfire": "laužas",
  "block.minecraft.soul_campfire": "sielų laužas",
  "block.minecraft.shroomlight": "šviesagrybis",
  "item.minecraft.honeycomb": "korys",
  "block.minecraft.bee_nest": "bičių lizdas",
  "block.minecraft.beehive": "avilys",
  "item.minecraft.honey_bottle": "medaus buteliukas",
  "block.minecraft.honey_block": "medaus blokas",
  "block.minecraft.honeycomb_block": "medaus korio blokas",
  "block.minecraft.lodestone": "magnetitas",
  "block.minecraft.netherite_block": "neterito blokas",
  "block.minecraft.ancient_debris": "senovinis fragmentas",
  "block.minecraft.target": "taikinys",
  "block.minecraft.crying_obsidian": "ašarotas obsidianas",
  "block.minecraft.blackstone": "juodakmenis",
  "block.minecraft.blackstone_slab": "juodakmenio pusblokis",
  "block.minecraft.blackstone_stairs": "juodakmenio laiptai",
  "block.minecraft.gilded_blackstone": "auksuotas juodakmenis",
  "block.minecraft.polished_blackstone": "šlifuotas juodakmenis",
  "block.minecraft.polished_blackstone_slab": "šlifuoto juodakmenio pusblokis",
  "block.minecraft.polished_blackstone_stairs": "šlifuoto juodakmenio laiptai",
  "block.minecraft.chiseled_polished_blackstone": "raižytas šlifuotas juodakmenis",
  "block.minecraft.polished_blackstone_bricks": "šlifuoto juodakmenio plytos",
  "block.minecraft.polished_blackstone_brick_slab": "šlifuoto juodakmenio plytų pusblokis",
  "block.minecraft.polished_blackstone_brick_stairs": "šlifuoto juodakmenio plytų laiptai",
  "block.minecraft.cracked_polished_blackstone_bricks": "sutrūkinėjusio šlifuoto juodakmenio plytos",
  "block.minecraft.respawn_anchor": "prisikėlimo inkaras",
}
export const lt_lt = items; 
